/**
 * Logout utility that handles cleanup for both Cognito and OIDC authentication
 */

export const performLogout = async (auth, logOutUser, viewManager) => {
    try {
        // Clear local state immediately
        viewManager.setIsLoader(true);
        viewManager.setUserData(null);
        viewManager.setIsLoggedIn(false);

        // Clear any stored tokens
        localStorage.removeItem('authToken');
        localStorage.removeItem('oidc.user');

        // Clear session storage
        sessionStorage.clear();

        // If authenticated via OIDC (Google)
        if (auth?.isAuthenticated) {
            try {
                // Try to remove user silently first
                if (typeof auth.removeUser === 'function') {
                    auth.removeUser();
                }

                // Fallback to silent signout
                if (typeof auth.signoutSilent === 'function') {
                    await auth.signoutSilent();
                }
            } catch (oidcError) {
                console.warn('OIDC logout warning:', oidcError);
                // Continue with logout even if OIDC cleanup fails
            }
        }

        // If authenticated via Cognito
        try {
            await logOutUser();
        } catch (cognitoError) {
            console.warn('Cognito logout warning:', cognitoError);
            // Continue with logout even if Cognito cleanup fails
        }

        return { success: true, message: 'Logout successful' };
    } catch (error) {
        console.error('Logout error:', error);
        // Ensure state is cleared even if logout fails
        viewManager.setUserData(null);
        viewManager.setIsLoggedIn(false);
        return { success: true, message: 'Logout completed with warnings' };
    } finally {
        viewManager.setIsLoader(false);
    }
};

export const clearAuthenticationState = (viewManager) => {
    viewManager.setUserData(null);
    viewManager.setIsLoggedIn(false);
    localStorage.removeItem('authToken');
    localStorage.removeItem('oidc.user');
    sessionStorage.clear();
};
